<div>
  <div id="renderComponent"></div>
  <div *ngIf="!isOpen && this.risk">
    <app-id-verification-confirmation
      [risk]="risk"
      [cmsLabels]="cmsLabels"
      [timerClickSubject]="timerClickSubject"
      (timerCompleteEvent)="emitTimerCompleteEvent()"
    ></app-id-verification-confirmation>
  </div>
</div>
